export const CAODEFINATIONSLIST_CAOSEARCH = 'CAODEFINATIONSLIST_CAOSEARCH';
export const CAODEFINATIONSLIST_CAOPAGE = 'CAODEFINATIONSLIST_CAOPAGE';
export const CAODEFINATIONSLIST_YEAR = 'CAODEFINATIONSLIST_YEAR';
